import { getConfigs as GetConfigsType } from '@generated/types';
import { GetConfigs } from '@services/user/queries';

import { client } from '../../index';

export async function getConfigSetting(configName: string): Promise<boolean> {
  let result = false;
  await client
    .query<GetConfigsType>({
      query: GetConfigs,
    })
    .then((response) => {
      const configs = response.data.getAllConfigs;
      const config = configs?.find((c) => c.name == configName);
      result = config?.value ? config.value === 'true' : false;
    })
    .catch(() => {
      result = false;
    });

  return result;
}
